module.exports = __webpack_public_path__ + "img/img_tongdian.6d84d3c4.png";